export default __webpack_public_path__ + "static/media/ambassador.3b15767f.svg";